import { jsx as _jsx } from "react/jsx-runtime";
import fileSize from 'filesize';
import { useNetwork } from '@tribeplatform/react-sdk/hooks';
import { useI18n } from '../i18n';
import { FileUpload } from './FileUpload';
export const ImageUpload = ({ label: _label, helper: _helper, ...restOfProps }) => {
    var _a, _b, _c, _d;
    const { $t } = useI18n();
    const { data: network } = useNetwork();
    const accept = (_c = (_b = (_a = network === null || network === void 0 ? void 0 : network.settings) === null || _a === void 0 ? void 0 : _a.imageTypesLimit) === null || _b === void 0 ? void 0 : _b.join(',')) !== null && _c !== void 0 ? _c : 'image/*';
    const label = _label !== null && _label !== void 0 ? _label : $t({
        id: 'Generics.ChooseAnImage',
        defaultMessage: 'Choose an image',
    });
    const helper = _helper !== null && _helper !== void 0 ? _helper : $t({
        id: 'Generics.ImageSizeLimit',
        defaultMessage: 'The image size limit is {size_limit}.',
    }, {
        size_limit: fileSize(((_d = network === null || network === void 0 ? void 0 : network.settings) === null || _d === void 0 ? void 0 : _d.imageSizeLimit) || 10000, {
            spacer: '',
        }),
    });
    return (_jsx(FileUpload, { label: label, helper: helper, accept: accept, ...restOfProps }, void 0));
};
//# sourceMappingURL=ImageUpload.js.map